// Country ISO-2 codes for flag rendering via flagcdn.com
export const COUNTRY_CODES = {
  "Afghanistan": "af",
  "Armenia": "am",
  "Azerbaijan": "az",
  "Bahrain": "bh",
  "Bangladesh": "bd",
  "Bhutan": "bt",
  "Brunei": "bn",
  "Cambodia": "kh",
  "China": "cn",
  "Chinese Taipei": "tw",
  "Cyprus": "cy",
  "Georgia": "ge",
  "Hong Kong": "hk",
  "India": "in",
  "Indonesia": "id",
  "Iran": "ir",
  "Iraq": "iq",
  "Israel": "il",
  "Japan": "jp",
  "Jordan": "jo",
  "Kazakhstan": "kz",
  "Khmer": "kh",
  "Kuwait": "kw",
  "Kyrgyzstan": "kg",
  "Laos": "la",
  "Lebanon": "lb",
  "Macau": "mo",
  "Malaysia": "my",
  "Maldives": "mv",
  "Mongolia": "mn",
  "Myanmar": "mm",
  "Nepal": "np",
  "North Korea": "kp",
  "Oman": "om",

  "Palestine": "ps",
  "Philippines": "ph",
  "Qatar": "qa",
  "Russia": "ru",
  "Saudi Arabia": "sa",
  "Singapore": "sg",
  "South Korea": "kr",
  "Sri Lanka": "lk",
  "Syria": "sy",
  "Taiwan": "tw",
  "Tajikistan": "tj",
  "Thailand": "th",
  "Timor-Leste": "tl",
  "Turkey": "tr",
  "Turkmenistan": "tm",
  "United Arab Emirates": "ae",
  "Uzbekistan": "uz",
  "Vietnam": "vn",
  "Yemen": "ye",
};

// International dialling codes per country
export const DIAL_CODES = {
  "Afghanistan": "+93",
  "Armenia": "+374",
  "Azerbaijan": "+994",
  "Bahrain": "+973",
  "Bangladesh": "+880",
  "Bhutan": "+975",
  "Brunei": "+673",
  "Cambodia": "+855",
  "China": "+86",
  "Chinese Taipei": "+886",
  "Cyprus": "+357",
  "Georgia": "+995",
  "Hong Kong": "+852",
  "India": "+91",
  "Indonesia": "+62",
  "Iran": "+98",
  "Iraq": "+964",
  "Israel": "+972",
  "Japan": "+81",
  "Jordan": "+962",
  "Kazakhstan": "+7",
  "Khmer": "+855",
  "Kuwait": "+965",
  "Kyrgyzstan": "+996",
  "Laos": "+856",
  "Lebanon": "+961",
  "Macau": "+853",
  "Malaysia": "+60",
  "Maldives": "+960",
  "Mongolia": "+976",
  "Myanmar": "+95",
  "Nepal": "+977",
  "North Korea": "+850",
  "Oman": "+968",

  "Palestine": "+970",
  "Philippines": "+63",
  "Qatar": "+974",
  "Russia": "+7",
  "Saudi Arabia": "+966",
  "Singapore": "+65",
  "South Korea": "+82",
  "Sri Lanka": "+94",
  "Syria": "+963",
  "Taiwan": "+886",
  "Tajikistan": "+992",
  "Thailand": "+66",
  "Timor-Leste": "+670",
  "Turkey": "+90",
  "Turkmenistan": "+993",
  "United Arab Emirates": "+971",
  "Uzbekistan": "+998",
  "Vietnam": "+84",
  "Yemen": "+967",
};

export const COUNTRY_3LETTER = {
  "Afghanistan": "AFG",
  "Armenia": "ARM",
  "Azerbaijan": "AZE",
  "Bahrain": "BHR",
  "Bangladesh": "BAN",
  "Bhutan": "BHU",
  "Brunei": "BRU",
  "Cambodia": "CAM",
  "China": "CHN",
  "Chinese Taipei": "TPE",
  "Cyprus": "CYP",
  "Georgia": "GEO",
  "Hong Kong": "HKG",
  "India": "IND",
  "Indonesia": "INA",
  "Iran": "IRI",
  "Iraq": "IRQ",
  "Israel": "ISR",
  "Japan": "JPN",
  "Jordan": "JOR",
  "Kazakhstan": "KAZ",
  "Khmer": "KHM",
  "Kuwait": "KUW",
  "Kyrgyzstan": "KGZ",
  "Laos": "LAO",
  "Lebanon": "LBN",
  "Macau": "MAC",
  "Malaysia": "MAS",
  "Maldives": "MDV",
  "Mongolia": "MGL",
  "Myanmar": "MYA",
  "Nepal": "NEP",
  "North Korea": "PRK",
  "Oman": "OMA",

  "Palestine": "PLE",
  "Philippines": "PHI",
  "Qatar": "QAT",
  "Russia": "RUS",
  "Saudi Arabia": "KSA",
  "Singapore": "SGP",
  "South Korea": "KOR",
  "Sri Lanka": "SRI",
  "Syria": "SYR",
  "Taiwan": "TWN",
  "Tajikistan": "TJK",
  "Thailand": "THA",
  "Timor-Leste": "TLS",
  "Turkey": "TUR",
  "Turkmenistan": "TKM",
  "United Arab Emirates": "UAE",
  "Uzbekistan": "UZB",
  "Vietnam": "VIE",
  "Yemen": "YEM",
};

export function getCountry3Letter(country) {
  if (!country) return "";
  return COUNTRY_3LETTER[country] || country.slice(0, 3).toUpperCase();
}

export const PARTICIPATING_COUNTRIES = Object.keys(COUNTRY_CODES);

export function flagUrl(country, size = 40) {
  const code = COUNTRY_CODES[country];
  if (!code) return null;
  // flagcdn.com is free CDN for SVG/PNG country flags
  return `https://flagcdn.com/w${size}/${code}.png`;
}

export function Flag({ country, size = 24, className = "" }) {
  const url = flagUrl(country, size > 24 ? 80 : 40);
  if (!url) return null;
  return (
    <img
      src={url}
      alt={country}
      width={size}
      height={Math.round(size * 0.75)}
      style={{ width: size, height: "auto", borderRadius: 2 }}
      className={`inline-block shadow-sm ${className}`}
      loading="lazy"
    />
  );
}
